import ContactDetailsModal from "./ContactDetailsModal"
export default ContactDetailsModal
